<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card>
      <v-card-title class="mx-3">
        {{ title }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-4 text-center">
        <!-- read 模式：显示原图 -->
        <template v-if="currentMode === 'read'">
          <v-card v-if="imgUrl" max-width="320" class="mx-auto">
            <v-img
              :src="imgUrl"
              @click.stop="$showFullscreenImages([imgUrl])"
            >
            </v-img>
          </v-card>
          <div v-else class="subtitle-1 grey--text py-8">
            {{ $t("materialsGroup.noImage") }}
          </div>
        </template>
        <!-- upload 模式：上传图片 -->
        <template v-if="currentMode === 'upload'">
          <!-- 图片预览 -->
          <v-card v-if="previewUrl" max-width="320" class="mx-auto mb-4">
            <v-img :src="previewUrl">
            </v-img>
          </v-card>
          <v-file-input
            show-size
            prepend-icon="fa-camera"
            accept="image/png, image/jpeg"
            persistent-hint
            :placeholder="$t('Material.imgPlaceholder')"
            v-model="imageFile"
          >
          </v-file-input>
        </template>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn
          v-if="currentMode === 'upload'"
          color="accent"
          :disabled="!imageFile"
          @click="save"
        >
          {{ $t("CRUD.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import store from "@/store";
import Files from "@/api/files";
import Materials from "@/api/materials";

export default {
  name: "DialogImages",

  props: {
    value: Boolean,
    currentMode: {
      type: String,
      default: "read",
    },
    currentItem: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    dialog: false,
    imageFile: null,
    previewUrl: "",
  }),

  computed: {
    imgUrl() {
      return this.currentItem ? this.currentItem.img_url : "";
    },
    title() {
      if (this.currentMode === "upload") {
        return this.$t("materialsGroup.uploadImage");
      }
      return this.$t("materialsGroup.readImage");
    },
  },

  methods: {
    async save() {
      if (!this.imageFile || !this.currentItem) return;

      store.dispatch("fullscreenLoading");

      try {
        // 1. 上传图片
        const uploadRes = await Files.imageUpload(this.imageFile, 1, "materials");
        if (!uploadRes.data || !uploadRes.data.status.isOK()) {
          store.dispatch("fullscreenLoadingStop");
          return;
        }

        const imgUrl = uploadRes.data.data.img_name || uploadRes.data.img_name || "";
        const thumbnail = uploadRes.data.data.thumbnail || uploadRes.data.thumbnail || "";

        // 2. 更新关联集图片
        const updateRes = await Materials.materialGroupUpdateImg({
          material_group: this.currentItem.material_group,
          img_url: imgUrl,
          thumbnail: thumbnail,
        });

        store.dispatch("fullscreenLoadingStop");

        if (updateRes.data && updateRes.data.status.isOK()) {
          this.$emit("success");
          this.dialog = false;
        }
      } catch (e) {
        store.dispatch("fullscreenLoadingStop");
      }
    },
  },

  watch: {
    value: {
      immediate: true,
      handler() {
        this.dialog = this.value;
        if (!this.value) {
          this.imageFile = null;
          this.previewUrl = "";
        }
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) {
          this.imageFile = null;
          this.previewUrl = "";
        }
      },
    },
    imageFile: {
      handler(file) {
        if (!file) {
          this.previewUrl = "";
          return;
        }
        const reader = new FileReader();
        reader.onload = (e) => {
          this.previewUrl = e.target.result;
        };
        reader.readAsDataURL(file);
      },
    },
  },
};
</script>
